module.exports = __webpack_public_path__ + "img/cointrends.6b49003f.svg";